import React, { useState } from "react";
import { Image } from "./styles";
import placeholder from "../../../../../../assets/images/placeholder.png";

export default function ProductImage({ src, name }) {
  const [defaultSrc, setDefaultSrc] = useState(src ?? placeholder);
  return (
    <Image
      height={54}
      width={54}
      src={defaultSrc}
      alt={name}
      onError={() => setDefaultSrc(placeholder)}
    />
  );
}
